<template>
  <div v-show="loaded" class="chatbot-page">
    <funcionalidade-header :titulo="tituloNavegacao" />
    <div class="chatbot-container">
      <div id="mosia-chat"/>
    </div>
  </div>
</template>
<script>
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import { mapGetters, mapState } from 'vuex'
import { encodeEmbedData } from '@/utils/utils'

export default {
  name: 'FuncionalidadeCustomizadaChatBotComponent',
  data () {
    return {
      loaded: false,
      funcionalidadeEmbed: null
    }
  },
  components: {
    FuncionalidadeHeader
  },
  computed: {
    ...mapState('SetupApp', ['config', 'funcionalidade']),
    ...mapGetters('Login', ['token']),
    ...mapGetters('SetupApp', [
      'aplicacao',
      'funcParams',
      'instanciaAplicacao',
      'bundle',
      'estilo'
    ]),
    tituloNavegacao () {
      return (this.funcionalidade || {}).nome
    },
    rotaChatMosia () {
      try {
        return this.aplicacao.rotas.chatBotClientWeb.rota
      } catch (ignored) {
        return ''
      }
    }
  },
  methods: {
    async init () {
      const embedConfig = {
        id: 'mosia-chat',
        url: this.rotaChatMosia,
        json: {
          configuration: {
            bundle: encodeEmbedData(this.bundle),
            idFuncionalidade: (this.funcionalidade || {}).idFuncionalidade,
            instanciaAplicacao: this.instanciaAplicacao,
            versao: this.aplicacao.versao,
            plataforma: 'web_embed', // FIXME: 26/02/2024 martinazzi Entender o que seria essa plataforma web_embed
            authorization: this.token
          },
          funcionalidade: this.funcionalidade,
          aplicacaoConfig: this.config,
          colorScheme: this.estilo
        }
      }
      this.funcionalidadeEmbed = window.omnichannelSDK.embed(embedConfig)

      this.funcionalidadeEmbed.on('CREATED', () => {
      })

      this.funcionalidadeEmbed.on('LOADING', () => {
      })

      setTimeout(() => {
        this.loaded = true
      }, 200)
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
.chatbot-page {
  height: 100%;
  max-height: 100%;
  min-height: 100%;
  display: flex;
  flex-flow: column;
}

.chatbot-container {
  flex: 1;
}
</style>
